import { useRef as L, useState as y, useEffect as x } from "react";
import g from "../../../hooks/useDebounce.js";
const $ = ({ tableRef: c, toolbarRef: s, disabled: i, on: l }) => {
  const p = L(!1), [h, u] = y(null), m = (o, n, t, e) => {
    if (!s || !("current" in s) || !s.current)
      return;
    const r = t <= e + n ? t - e : n;
    s.current.style.position = l === "focus" ? "relative" : "absolute", s.current.style.display = "flex", s.current.style.top = l === "focus" ? "0" : `${o.offsetTop + o.offsetHeight}px`, s.current.style.left = `${r}px`, s.current.style.width = `${e}px`;
  }, d = (o) => {
    if (!s || !("current" in s) || !s.current)
      return;
    const n = o.target, t = n.scrollLeft, e = n.scrollWidth, r = n.offsetWidth, f = e <= r + t ? e - r : t;
    s.current.style.left = `${f}px`, s.current.style.width = `${r}px`;
  }, v = g((o) => {
    var f;
    if (i)
      return;
    const n = o.target;
    if (n.closest(".fill-products-table-row-buttons"))
      return;
    const t = n.closest(".fill-products-table-row"), e = t == null ? void 0 : t.closest(".fill-products-table");
    if (!t || !e || !c || !("current" in c) || c.current !== e) {
      (f = e == null ? void 0 : e.parentElement) == null || f.removeEventListener("scroll", d), u(null);
      return;
    }
    const r = e.parentElement;
    r.addEventListener("scroll", d), u(t.id), m(t, r.scrollLeft, r.scrollWidth, r.offsetWidth);
  }, 5), a = (o) => {
    if (i)
      return;
    const n = o.target, t = n.closest(".fill-products-table-row"), e = t == null ? void 0 : t.closest(".fill-products-table");
    if (!t || !e || !c || !("current" in c) || c.current !== e)
      return;
    const r = e.parentElement;
    r.addEventListener("scroll", d), n.addEventListener("blur", E), u(t.id), p.current = !0, setTimeout(() => {
      m(t, r.scrollLeft, r.scrollWidth, r.offsetWidth);
    }, 0);
  }, E = (o) => {
    const n = o.target, t = n.closest(".fill-products-table-row"), e = t == null ? void 0 : t.closest(".fill-products-table");
    !t || !e || !c || !("current" in c) || c.current !== e || (e.parentElement.removeEventListener("scroll", d), n.removeEventListener("blur", E), p.current = !1, setTimeout(() => {
      p.current || u(null);
    }, 150));
  };
  return x(() => (!i && c ? (l === "hover" && document.addEventListener("mousemove", v), l === "focus" && document.addEventListener("focusin", a)) : u(null), () => {
    document.removeEventListener("mousemove", v), document.removeEventListener("focusin", a), u(null);
  }), [c, i, l]), { hoverId: h };
};
export {
  $ as default
};
